document.addEventListener('DOMContentLoaded', function() {

    const modal = document.querySelector('#modalAgregarClientes');
    if (!modal) return;

    const contClientes = modal.querySelector('.contClientes');
    const inputFiltro  = modal.querySelector('.input-filtro-buscar');
    if (!contClientes) return;

    let clientesCargados = false;

    // Abrir el modal al enfocar cualquier input selector de cliente
    document.addEventListener('focusin', function(e) {
        if (!e.target.classList.contains('inputAbrirModalCliente')) return;
        if (e.target.getAttribute('data-modal') !== 'modalAgregarClientes') return;

        const inputOrigen = modal.querySelector('input[name="origenModalClientes"]');
        if (inputOrigen) inputOrigen.value = e.target.getAttribute('data-origen') || '';

        const idModalOrigen = e.target.getAttribute('data-origen');
        if (idModalOrigen) {
            const modalOrigen = document.querySelector('#' + idModalOrigen);
            if (modalOrigen) {
                const inputIdCliente     = modalOrigen.querySelector('#idCliente');
                const inputCodCliente    = modalOrigen.querySelector('#codCliente');
                const inputNombreCliente = modalOrigen.querySelector('#nombreCliente');

                if (inputIdCliente && inputCodCliente && inputNombreCliente) {
                    inputIdCliente.value     = '';
                    inputCodCliente.value    = '';
                    inputNombreCliente.value = '';

                    inputIdCliente.classList.remove('inputRojo');
                    inputCodCliente.classList.remove('inputRojo');
                    inputNombreCliente.classList.remove('inputRojo');
                }
            }
        }

        modal.classList.add('modal--show');

        if (!clientesCargados) {
            cargarClientes();
        }
    });

    // Filtro de búsqueda dentro del modal
    if (inputFiltro) {
        inputFiltro.addEventListener('input', function() {
            const termino = this.value.trim().toLowerCase();
            const items = contClientes.querySelectorAll('.cliente');
            items.forEach(item => {
                const codigo = (item.getAttribute('data-codigo') || '').toLowerCase();
                const nombre = (item.getAttribute('data-nombre') || '').toLowerCase();
                item.style.display = (!termino || codigo.includes(termino) || nombre.includes(termino)) ? '' : 'none';
            });
        });
    }

    async function cargarClientes() {
        contClientes.innerHTML = '<p class="cargandoReferencias">Cargando clientes...</p>';

        try {
            const respuesta = await fetch('/api/configuracion/clientes/activos');
            const json      = await respuesta.json();

            if (respuesta.status !== 200 || !json.result) {
                contClientes.innerHTML = '<p class="no-info">No se pudieron cargar los clientes.</p>';
                return;
            }

            const clientes = json.result;

            if (!clientes.length) {
                contClientes.innerHTML = '<p class="no-info">No hay clientes activos disponibles.</p>';
                return;
            }

            contClientes.innerHTML = clientes.map(cliente => `
                <div class="cliente"
                     data-id="${cliente.idCliente}"
                     data-codigo="${escapeAttr(cliente.codigoSap)}"
                     data-nombre="${escapeAttr(cliente.nombreSap)}">
                    <article class="articuloCard">
                        <div class="articuloCardTitulo">
                            <h3>${escapeHtml(cliente.nombreSap || '')}</h3>
                        </div>
                        <dl class="articuloCardLista">
                            <dt>Código SAP:</dt>
                            <dd>${escapeHtml(cliente.codigoSap || '')}</dd>
                        </dl>
                    </article>
                </div>
            `).join('');

            clientesCargados = true;

        } catch (error) {
            console.error('Error al cargar clientes:', error);
            contClientes.innerHTML = '<p class="no-info">Error al cargar los clientes.</p>';
        }
    }

    // Delegación de clics sobre los clientes renderizados dinámicamente
    contClientes.addEventListener('click', function(e) {
        const item = e.target.closest('.cliente');
        if (!item) return;
        seleccionarCliente(item);
    });

    function seleccionarCliente(elemento) {
        const id     = elemento.getAttribute('data-id');
        const codigo = elemento.getAttribute('data-codigo');
        const nombre = elemento.getAttribute('data-nombre');

        const inputOrigenEl = modal.querySelector('input[name="origenModalClientes"]');
        if (!inputOrigenEl) return;

        const idModalOrigen = inputOrigenEl.value;
        const modalOrigen   = document.querySelector('#' + idModalOrigen);

        if (!idModalOrigen || !modalOrigen || !id || !codigo || !nombre) {
            alert('Faltan datos para completar la acción');
            window.location.reload();
            return;
        }

        const inputIdCliente     = modalOrigen.querySelector('#idCliente');
        const inputCodCliente    = modalOrigen.querySelector('#codCliente');
        const inputNombreCliente = modalOrigen.querySelector('#nombreCliente');

        if (!inputIdCliente || !inputCodCliente || !inputNombreCliente) {
            alert('No se encontraron los inputs destino');
            return;
        }

        inputIdCliente.value     = id;
        inputCodCliente.value    = codigo;
        inputNombreCliente.value = nombre;

        inputCodCliente.setAttribute('readonly', true);
        inputNombreCliente.setAttribute('readonly', true);

        modal.classList.remove('modal--show');
    }

    function escapeHtml(str) {
        return String(str)
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;');
    }

    function escapeAttr(str) {
        return String(str).replace(/"/g, '&quot;');
    }
});
